import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import Arrow from '../OnePicture/arrow';
import EcoImg from 'eco-design/base/eco-img';
import gtm from '@/utils/gtm';

interface Item1Props {
    pageType: 'max' | 'ultra' | 'classic';
}

const Item1: React.FC<Item1Props> = ({ pageType }: Item1Props = { pageType: 'max' }) => {
    const { locale } = getLocal();
    const { t } = useLang('OnePicture');

    const items = [
        {
            title: t('title1'),
            desc: t('desc1'),
            classic: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758770924787-zmy0hl-compressed-11111%201.jpg',
                pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758770924787-zmy0hl-compressed-11111%201.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758770924787-zmy0hl-compressed-11111%201.jpg',
            },
            max: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760410039071/product%20(1).jpg',
                pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758083406611-epn0v4-compressed-Frame%202094654406.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758083406611-epn0v4-compressed-Frame%202094654406.jpg',
            },
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758768149489-q33pbp-compressed-3%E5%BA%A6%E7%94%B5%201.jpg',
                pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758538116895-scsw3v-compressed-Frame%201612708216.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758781119418-v7dk4r-compressed-Frame%202094654415.jpg',
            },

            href: pageType === 'max' ? '#Output' : pageType === 'ultra' ? '#PriorityOutputs' : 'videoSection1',
        },
    ];

    const handleScrollInToView = (href: string, className: string, text: string) => {
        const element = document.getElementById(href.replace('#', ''));
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }

        gtm.push({
            __btn_id1: `${styles.NewRefine} .item-wrapper .${className}`,
            __btn_id2: text,
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    };

    return (
        <div className="item-wrapper">
            {/* {!haveProductImage && <EcoImg key={1} pc={items[0].pc} pad={items[0].pad} h5={items[0].h5} isOpenLazy={false} />}
            {haveProductImage &&  */}

            <div
                className="item item-1 GtmModuleData-btn-common d3m-one-picture-0"
                id="overview-item1"
                data-btn-id="one-picture-item-0"
                onClick={() => handleScrollInToView(items[0].href || '', 'd3m-one-picture-0', 'one-picture-item-0')}
            >
                <EcoImg key={2} pc={items[0][pageType].pc} pad={items[0][pageType].pad} h5={items[0][pageType].h5} isOpenLazy={true} />
                <div className="item1-text-wrapper">
                    <div className="title">{items[0].title}</div>
                    <div className="desc">{items[0].desc}</div>
                </div>
                <div className="arrow" onClick={() => handleScrollInToView(items[0].href || '', 'd3m-one-picture-0', 'one-picture-item-0')}>
                    <Arrow />
                </div>
            </div>
        </div>
    );
};

export default Item1;
